// import React, { useEffect, useState } from "react";
// import Api from "../../service/Api";
// import "../History/History.css";
// import ReactApexChart from "react-apexcharts";

// function History() {

//   const [history, setHistory] = useState([]);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [radarState, setRadarState] = useState(null);
//   const [radarData, setRadarData] = useState(null); // NOVO
//   const [loading, setLoading] = useState(true);

//   const getNivel = (valor) => {
//     const v = parseFloat(valor);

//     if (v <= 0) return "Nível 0";
//     if (v <= 25) return "Nível 1";
//     if (v <= 50) return "Nível 2";
//     if (v <= 75) return "Nível 3";
//     return "Nível 4";
//   };

//   useEffect(() => {

//     const getHistory = async () => {
//       try {

//         const response = await Api.historico();
//         console.log("Resposta da API:", response);

//         if (Array.isArray(response)) {

//           const ordenado = response.sort(
//             (a, b) => new Date(a.data) - new Date(b.data)
//           );

//           setHistory(ordenado);

//         } else {
//           setHistory([]);
//         }

//       } catch (error) {

//         console.error("Erro ao carregar histórico:", error);
//         setHistory([]);

//       } finally {
//         setLoading(false);
//       }
//     };

//     getHistory();

//   }, []);

//   const handleButtonClick = (item) => {
//     setSelectedItem(item);
//   };

//   const closeModal = () => {
//     setSelectedItem(null);
//     setRadarState(null);
//     setRadarData(null); // limpa também
//   };

//   useEffect(() => {

//     if (selectedItem && selectedItem.respostas_comp1) {

//       const data = transformHistory(selectedItem.respostas_comp1);

//       setRadarData(data); // guarda dados completos

//       setRadarState({
//         series: [{
//           name: "Porcentagem",
//           data: data.percentages.map(Number)
//         }],
//         options: {
//           chart: { type: "radar", toolbar: { show: false } },
//           xaxis: {
//             categories: [
//               "Visão",
//               "Governança e Atores",
//               "Ciclo Material",
//               "Ciclo Biológico e Hídrico",
//               "Espaço e Ambiente Construído",
//               "Equidade e Justiça Social" // ✅ corrigido
//             ],
//             labels: {
//               style: {
//                 colors: ["#333"],
//                 fontSize: "12px",
//                 fontWeight: "bold"
//               }
//             }
//           },
//           yaxis: { max: 100, show: false },
//           title: { text: "Diagnóstico Geral", align: "center" }
//         }
//       });

//     }

//   }, [selectedItem]);

  

//   if (loading)
//     return (
//       <div className="history-page-wrapper">
//         <p>Carregando...</p>
//       </div>
//     );

//   return (
//     <div className="history-page-wrapper">

//       <h2>Histórico de Avaliações</h2>

//       {history && history.length > 0 ? (

//         <ul className="history-list-items">

//           {history.map((item, index) => (
//             <li key={index}>

//               <button
//                 className="history-custom-btn"
//                 onClick={() => handleButtonClick(item)}
//               >
//                 {item.data ? item.data.slice(0, 10) : `Avaliação ${index + 1}`}
//               </button>

//             </li>
//           ))}

//         </ul>

//       ) : (
//         <p>Nenhum histórico encontrado.</p>
//       )}

//       {selectedItem && (

//         <div className="report-full-overlay">

//           <div className="report-modal-box">

//             <button className="report-close-x" onClick={closeModal}>
//               ✖
//             </button>

//             <div className="report-header-section">

//               <h2>Relatório de Acompanhamento</h2>

//               <p>
//                 Avaliação realizada em:{" "}
//                 <strong>{selectedItem.data?.slice(0, 10)}</strong>
//               </p>

//             </div>

//             {radarState && (

//               <div className="report-radar-wrapper">

//                 <ReactApexChart
//                   options={radarState.options}
//                   series={radarState.series}
//                   type="radar"
//                   height={600}
//                 />

//               </div>

//             )}

//             {/* ✅ NOVO RESUMO IGUAL PLANILHA */}
//              {radarData && (
//               <div className="report-summary">
//                 <h3>Resultado por categoria</h3>

//                 {/* Tabela de cima - Continua centralizada pelo estilo padrão */}
//                 <table>
//                   <thead>
//                     <tr>
//                       {radarState.options.xaxis.categories.map((cat, i) => (
//                         <th key={i}>{cat}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr>
//                       {radarData.percentages.map((valor, i) => (
//                         <td key={i}>{Number(valor).toFixed(2)}%</td>
//                       ))}
//                     </tr>
//                   </tbody>
//                 </table>

//                 {/* Tabela de baixo - Agora alinhada à ESQUERDA via classe table-levels */}
//                 <table className="table-levels">
//                   <thead>
//                     <tr>
//                       <th>Categoria</th>
//                       <th>Nível</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {radarData.percentages.map((valor, i) => (
//                       <tr key={i}>
//                         <td>{radarState.options.xaxis.categories[i]}</td>
//                         <td>{getNivel(valor)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}


         

//           </div>

//         </div>

//       )}

//     </div>
//   );
// }

// const transformHistory = (respostas) => {

//   if (!Array.isArray(respostas))
//     return { percentages: [0, 0, 0, 0, 0, 0], finalScore: 0 };

//   const sums = [0, 0, 0, 0, 0, 0];

//   const letterToNumber = {
//     A: 0,
//     B: 1,
//     C: 2,
//     D: 3
//   };

//   respostas.forEach((item, index) => {

//     const val = letterToNumber[item.answer] ?? 0;

//     if (index >= 0 && index <= 5) sums[0] += val;
//     else if (index >= 6 && index <= 24) sums[1] += val;
//     else if (index >= 25 && index <= 33) sums[2] += val;
//     else if (index >= 34 && index <= 38) sums[3] += val;
//     else if (index >= 39 && index <= 47) sums[4] += val;
//     else if (index >= 48 && index <= 55) sums[5] += val;

//   });

//   const divisores = [18, 57, 27, 15, 27, 12];

//   const percentages = sums.map((s, i) =>
//     ((s * 100) / divisores[i]).toFixed(2)
//   );

//   const total = percentages.reduce((acc, val) => acc + parseFloat(val), 0);
//   const finalScore = (total / 6).toFixed(2);

//   return {
//     percentages,
//     finalScore
//   };

// };

// export default History;



import React, { useEffect, useState } from "react";
import Api from "../../service/Api";
import "../History/History.css";
import ReactApexChart from "react-apexcharts";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function History() {
  const [history, setHistory] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [radarState, setRadarState] = useState(null);
  const [radarData, setRadarData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getNivel = (valor) => {
    const v = parseFloat(valor);
    if (v <= 25) return "Nível 0";
    if (v <= 50) return "Nível 1";
    if (v <= 75) return "Nível 2";
    if (v <= 100) return "Nível 3";
    return "Nível 4";
  };

  // --- NOVA FUNÇÃO PARA EXPORTAR PDF ---
const exportPDF = async () => {
  const input = document.querySelector(".report-modal-box");
  const uiElements = document.querySelectorAll(".report-close-x, .btn-export-pdf");
  
  uiElements.forEach(el => el.style.display = "none");

  try {
    // Adicionamos uma folga de segurança para garantir que o final não corte
    const extraSpace = 293; 
    const finalHeight = input.scrollHeight + extraSpace;

    const canvas = await html2canvas(input, {
      scale: 4, 
      useCORS: true,
      backgroundColor: "#F5F5F5",
      height: finalHeight, 
      windowHeight: finalHeight,
      onclone: (clonedDoc) => {
        const modalClone = clonedDoc.querySelector(".report-modal-box");
        if (modalClone) {
          modalClone.style.maxHeight = "none";
          modalClone.style.height = "auto";
          modalClone.style.overflow = "visible";
          modalClone.style.paddingBottom = `${extraSpace}px`;
        }
      }
    });

    const imgData = canvas.toDataURL("image/png", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");
    
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Primeira página
    pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight, undefined, 'FAST');
    heightLeft -= pdfHeight;

    // Se tiver mais conteúdo (as tabelas), ele cria a segunda página
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pdfHeight;
    }

    pdf.save(`Relatorio_${selectedItem.data?.slice(0, 10)}.pdf`);

  } catch (err) {
    console.error("Erro ao exportar:", err);
  } finally {
    uiElements.forEach(el => el.style.display = "block");
  }
};



//

  useEffect(() => {
    const getHistory = async () => {
      try {
        const response = await Api.historico();
        if (Array.isArray(response)) {
          const ordenado = response.sort(
            (a, b) => new Date(a.data) - new Date(b.data)
          );
          setHistory(ordenado);
        } else {
          setHistory([]);
        }
      } catch (error) {
        console.error("Erro ao carregar histórico:", error);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };
    getHistory();
  }, []);

  const handleButtonClick = (item) => {
    setSelectedItem(item);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setRadarState(null);
    setRadarData(null);
  };

  useEffect(() => {
    if (selectedItem && selectedItem.respostas_comp1) {
      const data = transformHistory(selectedItem.respostas_comp1);
      setRadarData(data);
      setRadarState({
        series: [{
          name: "Porcentagem",
          data: data.percentages.map(Number)
        }],
        options: {
          chart: { type: "radar", toolbar: { show: false } },
          xaxis: {
            categories: [
              "Visão",
              "Governança e Atores",
              "Ciclo Material",
              "Ciclo Biológico e Hídrico",
              "Espaço e Ambiente Construído",
              "Equidade e Justiça Social"
            ],
            labels: {
              style: {
                colors: ["#333"],
                fontSize: "12px",
                fontWeight: "bold"
              }
            }
          },
          yaxis: { max: 100, show: false },
          title: { text: "Diagnóstico Geral", align: "center" }
        }
      });
    }
  }, [selectedItem]);

  if (loading)
    return (
      <div className="history-page-wrapper">
        <p>Carregando...</p>
      </div>
    );

  return (
    <div className="history-page-wrapper">
      <h2>Histórico de Avaliações</h2>

      {history && history.length > 0 ? (
        <ul className="history-list-items">
          {history.map((item, index) => (
            <li key={index}>
              <button
                className="history-custom-btn"
                onClick={() => handleButtonClick(item)}
              >
                {item.data ? item.data.slice(0, 10) : `Avaliação ${index + 1}`}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>Nenhum histórico encontrado.</p>
      )}

      {selectedItem && (
        <div className="report-full-overlay">
          <div className="report-modal-box">
            <button className="report-close-x" onClick={closeModal}>
              ✖
            </button>

            <div className="report-header-section">
              <h2>Relatório de Acompanhamento</h2>
              <p>
                Avaliação realizada em:{" "}
                <strong>{selectedItem.data?.slice(0, 10)}</strong>
              </p>
              
              {/* BOTÃO DE EXPORTAR PDF */}
              <button 
                className="btn-export-pdf" 
                onClick={exportPDF}
                style={{
                  marginTop: "10px",
                  padding: "8px 16px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}
              >
                Baixar Relatório PDF
              </button>
            </div>

            {radarState && (
              <div className="report-radar-wrapper">
                <ReactApexChart
                  options={radarState.options}
                  series={radarState.series}
                  type="radar"
                  height={600}
                />
              </div>
            )}

            {radarData && (
              <div className="report-summary">
                <h3>Resultado por categoria</h3>
                <table>
                  <thead>
                    <tr>
                      {radarState.options.xaxis.categories.map((cat, i) => (
                        <th key={i}>{cat}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {radarData.percentages.map((valor, i) => (
                        <td key={i}>{Number(valor).toFixed(2)}%</td>
                      ))}
                    </tr>
                  </tbody>
                </table>

                <table className="table-levels">
                  <thead>
                    <tr>
                      <th>Categoria</th>
                      <th>Nível</th>
                    </tr>
                  </thead>
                  <tbody>
                    {radarData.percentages.map((valor, i) => (
                      <tr key={i}>
                        <td>{radarState.options.xaxis.categories[i]}</td>
                        <td>{getNivel(valor)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const transformHistory = (respostas) => {
  if (!Array.isArray(respostas))
    return { percentages: [0, 0, 0, 0, 0, 0], finalScore: 0 };

  const sums = [0, 0, 0, 0, 0, 0];
  const letterToNumber = { A: 0, B: 1, C: 2, D: 3 };

  respostas.forEach((item, index) => {
    const val = letterToNumber[item.answer] ?? 0;
    if (index >= 0 && index <= 5) sums[0] += val;
    else if (index >= 6 && index <= 24) sums[1] += val;
    else if (index >= 25 && index <= 33) sums[2] += val;
    else if (index >= 34 && index <= 38) sums[3] += val;
    else if (index >= 39 && index <= 47) sums[4] += val;
    else if (index >= 48 && index <= 55) sums[5] += val;
  });

  const divisores = [18, 57, 27, 15, 27, 12];
  const percentages = sums.map((s, i) =>
    ((s * 100) / divisores[i]).toFixed(2)
  );

  const total = percentages.reduce((acc, val) => acc + parseFloat(val), 0);
  const finalScore = (total / 6).toFixed(2);

  return { percentages, finalScore };
};

export default History;